import { IconContainer } from "components/modules/Editors/MemeGenerator/Containers/IconContainer/IconContainer";
import { MemeGeneratorState } from "store/features/memeGenerator/types";

interface IconProps {
    icon: NonNullable<MemeGeneratorState["meme"]>["icons"][number];
    xRatio: number;
    yRatio: number;
}

export const Icon = ({ icon, xRatio, yRatio }: IconProps) => {
    return (
        <IconContainer
            icon={{
                ...icon,
                settings: {
                    ...icon.settings,
                    left: icon.settings.left * xRatio,
                    top: icon.settings.top * yRatio,
                    width: icon.settings.width * xRatio,
                    height: icon.settings.height * yRatio,
                },
            }}
            isDownloading={true}
        >
            <></>
        </IconContainer>
    );
};
